import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomerAlertsComponent } from 'src/components/customer-alerts.component'
import { MultipassPlanComponent } from './multipass-plan.component'
import SubscriptionDataService from './subscription-data.service'

import { MaterialModule } from 'modules/material/material.module'
import { MatSidenavModule } from '@angular/material/sidenav'
import { FuzzySearchModule } from 'src/pipes/fuzzy-search/fuzzy-search.module'
import { SearchBarModule } from 'src/modules/search-bar/search-bar.module'
import { CollapseModule } from 'ngx-bootstrap/collapse'
import { QuantitySelectorModule } from '../quantity-selector/quantity-selector.module'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CustomCheckboxComponent } from 'src/components/custom-checkbox.component'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { CustomRadioButtonComponent } from 'src/components/custom-radio-button.component'
import { KeepHtmlModule } from "src/pipes/keep-html/keep-html.module"
import { PassEventToDirectiveModule } from 'src/directives/pass-event-to/pass-event-to.module'
import { IsDisabledDirectiveModule } from 'src/directives/is-disabled/is-disabled.module'
import { RouterModule } from '@angular/router'
import { ModalModule } from '../modal/modal.module'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  imports: [
    CommonModule,
    CollapseModule,
    FuzzySearchModule,
    MaterialModule,
    MatSidenavModule,
    SearchBarModule,
    FormsModule,
    ReactiveFormsModule,
    PopoverModule,
    KeepHtmlModule,
    PassEventToDirectiveModule,
    IsDisabledDirectiveModule,
    QuantitySelectorModule,
    RouterModule,
    ModalModule,
    SharedModule
  ],
  declarations: [
    MultipassPlanComponent,
    CustomCheckboxComponent,
    CustomRadioButtonComponent,
    CustomerAlertsComponent,
  ],
  exports: [
    MultipassPlanComponent,
  ],
  providers: [
    SubscriptionDataService
  ],
})

export class MultipassPlanModule {}
